import React, { useState, useEffect } from "react";
import { Toast } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import {CleanCrossIcon} from "./Icons";
import {useSelector} from "react-redux"
import {getInProductMKTPopupSettings} from "./utils"

const InProductMKTPopup = () => {
    const [show, setShow] = useState(false);
    const [customMarginBottom, setCustomMarginBottom] = useState("0");
    const [inProductMKTPopupSettings, setInProductMKTPopupSettings] = useState({});

    const {stickyFooterElement, mobile_medium, user_profile} = useSelector((state) => ({
        stickyFooterElement: state.appReducer.stickyFooterElement,
        mobile_medium: state.appReducer.mobile_medium,
        user_profile: state.myAccountReducer.user_profile,
    }));

    const toastName = inProductMKTPopupSettings && inProductMKTPopupSettings.toastName;
    const ctaURL = inProductMKTPopupSettings && inProductMKTPopupSettings.ctaURL;
    const textLabel = inProductMKTPopupSettings && inProductMKTPopupSettings.textLabel;
    const ctaLabel = inProductMKTPopupSettings && inProductMKTPopupSettings.ctaLabel;
    const toastNameOpened = toastName && `${toastName}_opened`;

    const closeToast = () => {
        setShow(false);
    }

    const getIntercomHeight = (intercomStickyElement) => {
        return `${parseInt(window.getComputedStyle(intercomStickyElement).height) + parseInt(window.getComputedStyle(intercomStickyElement).bottom)}px`;
    }

    const checkForStickyElements = () => {
        const potentialStickyElement = document.querySelector(".fixed-footer-element");
        const intercomStickyElement = document.querySelector(".intercom-launcher");
        const computedMarginBottom = potentialStickyElement ? window.getComputedStyle(potentialStickyElement).height : mobile_medium && intercomStickyElement ? getIntercomHeight(intercomStickyElement) : 0;
        if (computedMarginBottom) {
            setCustomMarginBottom(computedMarginBottom);
        } else {
            setCustomMarginBottom("0");
        }
    };

    useEffect(() => {
        setInProductMKTPopupSettings(getInProductMKTPopupSettings(user_profile));
    },[])

    useEffect(() => {
        if (toastNameOpened && !sessionStorage.getItem(toastNameOpened)) {
            setTimeout(() => {
                checkForStickyElements();
                setShow(true);
                sessionStorage.setItem(toastNameOpened, "1");
            }, 1000);
        } else {
            closeToast();
        }
    },[inProductMKTPopupSettings])

    useEffect(() => {
        checkForStickyElements();
    },[stickyFooterElement])

    useEffect(() => {
        setInProductMKTPopupSettings(getInProductMKTPopupSettings(user_profile));
    },[user_profile])

    if (!toastName) { return null; }

    return (
        <Toast
            onClose={closeToast}
            data-testid="toast"
            show={show}
            className="in-product-toast__container"
            style={{marginBottom: customMarginBottom}}
        >
            <div className="in-product-toast__body">
                <div className="in-product-toast__title">
                    {textLabel}
                </div>
                <Button
                    className="in-product-toast__cta"
                    variant="clean"
                    href={ctaURL}
                >
                    {ctaLabel}
                </Button>
                <Button
                    className="in-product-toast__close-button"
                    variant="clean"
                    onClick={closeToast}
                >
                    <CleanCrossIcon
                        style={{width: 20}}
                        label="Close"
                    />
                </Button>
            </div>
        </Toast>
    )
}

export default InProductMKTPopup;